import React from 'react';
import { Link } from 'react-router-dom';
import { TwitterIcon, LinkedinIcon, FacebookIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-au-green-dark text-white" data-id="element-202">
      <div className="h-1 bg-au-gold" data-id="element-203"></div>
      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-204">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-205">
          <div data-id="element-206">
            <h3 className="font-bold text-lg mb-4" data-id="element-207">About</h3>
            <ul className="space-y-2" data-id="element-208">
              <li data-id="element-209">
                <Link to="/about" className="hover:text-au-gold transition-colors" data-id="element-210">
                  About Us
                </Link>
              </li>
              <li data-id="element-211">
                <Link to="/about" className="hover:text-au-gold transition-colors" data-id="element-212">
                  Leadership
                </Link>
              </li>
              <li data-id="element-213">
                <Link to="/about" className="hover:text-au-gold transition-colors" data-id="element-214">
                  Mandate
                </Link>
              </li>
              <li data-id="element-215">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-216">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-217">
            <h3 className="font-bold text-lg mb-4" data-id="element-218">Procurement</h3>
            <ul className="space-y-2" data-id="element-219">
              <li data-id="element-220">
                <Link to="/bids" className="hover:text-au-gold transition-colors" data-id="element-221">
                  Bids & Tenders
                </Link>
              </li>
              <li data-id="element-222">
                <Link to="/procurement/annual-plan" className="hover:text-au-gold transition-colors" data-id="element-223">
                  Annual Plan
                </Link>
              </li>
              <li data-id="element-224">
                <Link to="/procurement/contract-awards" className="hover:text-au-gold transition-colors" data-id="element-225">
                  Contract Awards
                </Link>
              </li>
              <li data-id="element-226">
                <Link to="/procurement/supplier-registration" className="hover:text-au-gold transition-colors" data-id="element-227">
                  Supplier Registration
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-228">
            <h3 className="font-bold text-lg mb-4" data-id="element-229">Resources</h3>
            <ul className="space-y-2" data-id="element-230">
              <li data-id="element-231">
                <Link to="/projects" className="hover:text-au-gold transition-colors" data-id="element-232">
                  Projects
                </Link>
              </li>
              <li data-id="element-233">
                <Link to="/procurement/manual" className="hover:text-au-gold transition-colors" data-id="element-234">
                  Procurement Manual
                </Link>
              </li>
              <li data-id="element-235">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-236">
                  Publications
                </a>
              </li>
              <li data-id="element-237">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-238">
                  Media Centre
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-239">
            <h3 className="font-bold text-lg mb-4" data-id="element-240">Contact</h3>
            <p className="mb-2" data-id="element-241">African Union Commission</p>
            <p className="mb-2" data-id="element-242">London Office, United Kingdom</p>
            <p className="mb-2" data-id="element-243">info@aucommission.org</p>
            <p data-id="element-244">+44 (0) 20 4571 0123 (Procurement)</p>
            <p data-id="element-245">+44 (0) 20 4571 1964</p>
          </div>
        </div>

        <div className="border-t border-au-green pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-246">
          <div className="flex items-center gap-4" data-id="element-247">
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-248">
              <TwitterIcon size={20} data-id="element-249" />
            </a>
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-250">
              <LinkedinIcon size={20} data-id="element-251" />
            </a>
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-252">
              <FacebookIcon size={20} data-id="element-253" />
            </a>
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-254">
              <YoutubeIcon size={20} data-id="element-255" />
            </a>
          </div>
          <p className="text-sm text-gray-300" data-id="element-256">
            © 2026 African Union. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}